import ExecAPI from 'appRoot/api/api';

// TEMPORARY admin-only API of the Code Review Diagnostics page (Controllers/CodeReviewDiagnostics.cs).

/**
 * Lists the configured and connected release agents ({ agents: [{ Name, Id, Version, Connected }] }).
 */
export function ListAgents()
{
	return ExecAPI("CodeReviewDiagnostics/ListAgents");
}
/**
 * Gets the agent's code-review info.  An agent without code-review jobs enabled returns its error text in agentError.
 * @param {String} agentName Agent name.
 */
export function GetAgentInfo(agentName)
{
	return ExecAPI("CodeReviewDiagnostics/GetAgentInfo", { agentName });
}
/**
 * Starts a code-review job.  The server assigns the job ID and validates the spec first.
 * @param {Object} request { agentName, kind, repo, cloneUrl, checkoutSha, siblingRepos: [{ repo, cloneUrl }], prompt, model, effort, maxBudgetUsd, allowedTools, disallowedTools, jsonSchema, timeoutMinutes }
 */
export function BeginJob(request)
{
	return ExecAPI("CodeReviewDiagnostics/BeginJob", request);
}
/**
 * Gets a job's status and log tail.  With includeResult, a finished job also returns ResultJson and a Classification.
 * @param {String} agentName Agent name.
 * @param {String} jobId Job ID.
 * @param {Boolean} includeResult True to include the result of a finished job.
 * @param {String} model The model the job was started with (for classification).
 */
export function GetJobStatus(agentName, jobId, includeResult, model)
{
	return ExecAPI("CodeReviewDiagnostics/GetJobStatus", { agentName, jobId, includeResult, model });
}
/**
 * Cancels a job.
 * @param {String} agentName Agent name.
 * @param {String} jobId Job ID.
 */
export function CancelJob(agentName, jobId)
{
	return ExecAPI("CodeReviewDiagnostics/CancelJob", { agentName, jobId });
}
/**
 * Lists the agent's jobs, newest first.
 * @param {String} agentName Agent name.
 */
export function ListJobs(agentName)
{
	return ExecAPI("CodeReviewDiagnostics/ListJobs", { agentName });
}
/**
 * Gets the head commit of a repository's master (or main) branch from Azure DevOps ({ branch, sha }).
 * @param {String} repo Repository name.
 */
export function GetBranchHead(repo)
{
	return ExecAPI("CodeReviewDiagnostics/GetBranchHead", { repo });
}
